module.exports = __webpack_public_path__ + "static/img/wear_01.55b2175.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wear_01.png
// module id = qpKx
// module chunks = 1